<div class="order-options">
    <div *ngIf="multipleChoice" [ngClass]="{'active-order-option': allSelected}" (click)="selectAll()" class="order-option">Todos </div>
    <div *ngFor="let option of chipsToDisplay; let i = index" (click)="onClickChip(option,i)" [ngClass]="{'active-order-option': option.status && !isEmoji, 'active-order-option-emoji': option.status && isEmoji}" class="order-option mat-icon-container">
        <mat-icon *ngIf="leftIcon" class="icon-chip">{{leftIcon}}</mat-icon> {{option.label}}
    </div>
</div>